const PENDO_EVENTS = {
	SEND: "predictive_scoring_send",
	VIEW_SCORE: "predictive_scoring_view_score",
	TOGGLE_KPI: "predictive_scoring_toggle_kpi",
	EXPORT: "predictive_scoring_export",
	ADMIN_ENABLE: "predictive_scoring_admin_enable",
};

function trackPendoEvent(eventName, properties = {}) {
	if (window.pendo && typeof window.pendo.track === "function") {
		window.pendo.track(eventName, properties);
	}
}

export function trackScoringInitiated(entityCount, kpiCount, libraryId, advertiserId) {
	trackPendoEvent(PENDO_EVENTS.SEND, { entityCount, kpiCount, libraryId, advertiserId });
}

export function trackScoreViewed(score, kpi, creativeId) {
	trackPendoEvent(PENDO_EVENTS.VIEW_SCORE, { score, kpi, creativeId });
}

export function trackKpiToggle(fromKpi, toKpi) {
	trackPendoEvent(PENDO_EVENTS.TOGGLE_KPI, { fromKpi, toKpi });
}

export function trackExport(entityType, libraryId) {
	trackPendoEvent(PENDO_EVENTS.EXPORT, { entityType, libraryId });
}

export function trackAdminEnable(advertiserId) {
	trackPendoEvent(PENDO_EVENTS.ADMIN_ENABLE, { advertiserId });
}

export default PENDO_EVENTS;
